import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { NavLink } from 'react-router-dom';
import { logout } from '../auth/logout';
import { Logo } from './Logo';
import { useSession } from '../context/session/useSession';
import clsx from 'clsx';
import UserAvatar from '../components/Settings/AccountPage/UserAvatar';

const anonNavigation = [
  { name: 'Create proxy pool', href: '/proxy-pool/create' },
  { name: 'Buy proxy', href: '/proxies/buy' },
  { name: 'Sign in', href: '/account/signin' },
];
const customerNavigation = [
  { name: 'Dashboard', href: '/' },
  { name: 'Create proxy pool', href: '/proxy-pool/create' },
  { name: 'Buy proxy data volume', href: '/proxies/buy' },
];

const useNavigation = () => {
  const { session } = useSession();
  const navigation = session ? customerNavigation : anonNavigation;

  return navigation;
};

export function TopNav() {
  const { session } = useSession();
  const navigation = useNavigation();

  return (
    <Disclosure as="nav" className="bg-gray-800">
      <div className="primary">
        <div className="relative flex h-16 items-center justify-between">
          <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
            {/* Mobile menu button*/}
            <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
              <span className="absolute -inset-0.5" />
              <span className="sr-only">Open main menu</span>
              <Bars3Icon
                aria-hidden="true"
                className="block h-6 w-6 group-data-[open]:hidden"
              />
              <XMarkIcon
                aria-hidden="true"
                className="hidden h-6 w-6 group-data-[open]:block"
              />
            </DisclosureButton>
          </div>
          <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
            <div className="flex flex-shrink-0 items-center mb-2">
              <Logo />
              {/* <img
                alt="FloppyData"
                src=""
                className="h-8 w-auto"
              /> */}
            </div>
            <div className="hidden sm:ml-6 sm:block">
              <div className="flex space-x-4">
                {navigation.map((item) => (
                  <NavLink
                    key={item.name}
                    to={item.href}
                    // aria-current={item.current ? 'page' : undefined}
                    className={({ isActive }) =>
                      clsx(
                        isActive
                          ? 'bg-gray-900 text-white'
                          : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                        'rounded-md px-3 py-2 text-sm font-medium'
                      )
                    }
                  >
                    {item.name}
                  </NavLink>
                ))}
              </div>
            </div>
          </div>
          <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
            {!session && (
              <div className="hidden sm:ml-6 sm:block">
                <div className="flex space-x-4">
                  <NavLink
                    to={'/account/signup'}
                    // aria-current={item.current ? 'page' : undefined}
                    className={() =>
                      clsx(
                        'inline-flex mr-2 items-center rounded-md bg-indigo-500 px-3 py-2 text-sm font-semibold text-white ',
                        'shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 ',
                        'focus-visible:outline-offset-2 focus-visible:outline-indigo-500'
                      )
                    }
                  >
                    Sign up
                  </NavLink>
                </div>
              </div>
            )}

            {/* Profile dropdown */}
            <Menu as="div" className="relative ml-3">
              <div>
                <MenuButton className="relative flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                  <span className="absolute -inset-1.5" />
                  <span className="sr-only">Open user menu</span>
                  <UserAvatar />
                </MenuButton>
              </div>
              {!!session && (
                <MenuItems
                  transition
                  className="absolute right-0 z-10 mt-2 overflow-x-hidden w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                  <MenuItem>
                    <span className="block px-4 py-2 text-sm text-gray-700  text-ellipsis overflow-hidden">
                      {session.user.user_metadata.name ?? session.user.email}
                    </span>
                  </MenuItem>
                  <MenuItem>
                    <NavLink
                      to="/settings"
                      className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 "
                    >
                      Settings
                    </NavLink>
                  </MenuItem>
                  <MenuItem>
                    <a
                      href="#"
                      onClick={logout}
                      className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 "
                    >
                      Sign out
                    </a>
                  </MenuItem>
                </MenuItems>
              )}

              {!session && (
                <MenuItems
                  transition
                  className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                  <MenuItem>
                    <a
                      href="/proxies/buy"
                      className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100"
                    >
                      Buy proxy
                    </a>
                  </MenuItem>
                  <MenuItem>
                    <a
                      href="/account/signin"
                      className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100"
                    >
                      Log in
                    </a>
                  </MenuItem>
                  <MenuItem>
                    <a
                      href="/account/signup"
                      className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100"
                    >
                      Sign up
                    </a>
                  </MenuItem>
                </MenuItems>
              )}
            </Menu>
          </div>
        </div>
      </div>

      <DisclosurePanel className="sm:hidden">
        <div className="space-y-1 px-2 pb-3 pt-2">
          {navigation.map((item) => (
            <DisclosureButton
              key={item.name}
              as="a"
              href={item.href}
              className={() => {
                const active = window.location.pathname === item.href;
                return clsx(
                  { 'bg-gray-900 text-white': active },
                  'text-gray-300 hover:bg-gray-700 hover:text-white',
                  'block rounded-md px-3 py-2 text-base font-medium'
                );
              }}
            >
              {item.name}
            </DisclosureButton>
          ))}
        </div>
      </DisclosurePanel>
    </Disclosure>
  );
}
